import React from 'react'
import PageWrapper from 'js/view/component/page-wrapper'
import { Row, Col } from 'react-bootstrap'
import classnames from 'classnames'
import Iframe from 'view/component/iframe'
import styles from './styles'

const SuccessfulPlayerJourney = () => {
  return (<>
    <PageWrapper>
      <Row className={styles.hero}>
        <Col className={styles.heading_container} />
      </Row>
      <div className={styles.main_content} >
        <div className={styles.inner_wrapper}>
          <Row className='h-100'>
            <Iframe
              style={styles.iframe_height}
              url='https://analytics.premierleague.com/ds/extensions/PLFS-successful-player-journey/PLFS-successful-player-journey.html'
            />
          </Row>
        </div>
        <a name='bottom' />
      </div>
    </PageWrapper>
  </>
  )
}

export default SuccessfulPlayerJourney
